import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-icon-link-renderer",
  template: `
    <span
      *ngIf="linkObj.show"
      [ngClass]="{
        'black-icon': linkObj.iconColor === 'black',
        'green-icon': linkObj.iconColor === 'green'
      }"
    >
      <span class="icon-link" *ngIf="hasCallBack">
        <va-icon
          size="small"
          [name]="linkObj.icon"
          isFontAwesome="true"
          class="link-icon"
          nz-tooltip
          nzTooltipTitle="{{ linkObj.title }}"
          (click)="linkObj.clickCallback(linkObj.clickData)"
        ></va-icon>
      </span>
      <span class="icon-link" *ngIf="!hasCallBack">
        <va-icon
          size="small"
          [name]="linkObj.icon"
          isFontAwesome="true"
          class="link-icon"
          nz-tooltip
          nzTooltipTitle="{{ linkObj.title }}"
        ></va-icon>
      </span>
      <span class="icon-text" *ngIf="hasText">
        <span (click)="linkObj.clickCallback(linkObj.clickData)">
          {{ linkObj.linkText }}
        </span>
      </span>
    </span>
  `,
  styles: [
    `
      .icon-link {
        cursor: pointer;
        color: #1874ae;
        font-size: 14px;
      }
      .icon-text {
        cursor: pointer;
        color: #1874ae;
        font-size: 12px;
      }
      .black-icon .icon-link {
        color: #000;
      }
      .green-icon .icon-link {
        color: #008000;
      }
    `,
  ],
})
export class IconLinkRendererComponent implements OnInit {
  @Input() linkObj: any;
  hasCallBack = false;
  hasText = false;

  ngOnInit() {
    this.hasCallBack = this.linkObj.clickCallback !== null;
    this.hasText = this.linkObj.linkText !== undefined;
  }
}
